import { Axios } from 'axios'
import { RootState } from '@/store'
import { HospitalClinicKbnType, Kamoku, KeieiJokyoKmkTypeType } from '@/repositories/keiei-joho/data'
import { ResponseKeieiJokyoSetting, ResponseKeieiJokyoSettingItem } from '@/repositories/keiei-joho/keiei-jokyo/data'

type PostParamItem = {
  hospitalClinicKbn: HospitalClinicKbnType;
  kmkType: KeieiJokyoKmkTypeType;
  settings: Kamoku[];
}

export interface KeieiJokyoSettingRepository {
  list (): Promise<ResponseKeieiJokyoSetting>;
  save (postParam: ResponseKeieiJokyoSettingItem[]): Promise<void>;
}

export class KeieiJokyoSettingRepositoryImpl implements KeieiJokyoSettingRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/keiei-jokyo/setting`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseKeieiJokyoSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (params: ResponseKeieiJokyoSettingItem[]): Promise<void> {
    const postParam: PostParamItem[] = params.map(p => ({
      hospitalClinicKbn: p.hospitalClinicKbn,
      kmkType: p.kmkType,
      settings: p.setting.targets
    }))
    await this.http.post(this.baseUrl, postParam)
  }
}
